export default "__VITE_ASSET__CmoxM$tW__"